"use strict";

var _construct = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _toConsumableArray = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coerceEnumValue = exports.assertIsEnumValue = exports.fold = exports.asSingleton = exports.enumReverseMap = exports.Enum = exports.cast = void 0;

var Set_1 = require("fp-ts/lib/Set");

var t = __importStar(require("io-ts"));

var io_ts_reporters_1 = require("io-ts-reporters");

var errors_1 = require("../errors");
/**
 * Cast an unknown value using an `io-ts` schema. If validation fails, throw an error.
 * If it passes, cast the value to the schema's interface.
 * @param {unknown} data - Object to validate
 * @param {T} schema - Schema to validate against
 * @param {boolean?} includeDataInError - Whether to include data in error or not.
 * @returns {t.TypeOf<T>} the validated object
 */


function cast(data, schema) {
  var includeDataInError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var decoded = schema.decode(data);

  if (decoded.isLeft()) {
    var errors = io_ts_reporters_1.reporter(decoded);
    throw new errors_1.CastError(errors, includeDataInError ? data : undefined);
  }

  return data;
}

exports.cast = cast;
/**
 * Convert a typescript enum to an io-ts enum
 * @see https://github.com/gcanti/io-ts/issues/216
 * @example backend/src/types/delivery.ts
 */

var Enum = /*#__PURE__*/function (_t$Type) {
  _inherits(Enum, _t$Type);

  var _super = _createSuper(Enum);

  function Enum(e, name) {
    var _this;

    _classCallCheck(this, Enum);

    _this = _super.call(this, name || 'enum', function (u) {
      return Object.values(_this.enumObject).some(function (v) {
        return v === u;
      });
    }, function (u, c) {
      return _this.is(u) ? t.success(u) : t.failure(u, c);
    }, t.identity); // tslint:disable-next-line:variable-name

    _this._tag = 'EnumType';
    _this.enumObject = e;
    return _this;
  }

  return Enum;
}(t.Type);

exports.Enum = Enum;
/**
 * Given an arbitrary enumeration, generate the reverse lookup map.
 *
 * @param {object} enumeration
 * The enumeration.
 *
 * @returns {Map}
 * A Mapping where the key is the value and the value is the key.
 */

function enumReverseMap(enumeration) {
  return new Map(Object.entries(enumeration).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return [value, key];
  }));
}

exports.enumReverseMap = enumReverseMap;
/**
 * Given a constructor, cast it as a singleton.
 *
 * @param {T} constructor
 * A constructor.
 *
 * @returns {T}
 * The constructor is returned, wrapped in Proxy such that it returns the first instance
 * of itself.
 */

function asSingleton(constructor) {
  var instance;
  return new Proxy(constructor, {
    construct: function construct(target, args) {
      return instance = instance || _construct(target, _toConsumableArray(args)), instance;
    }
  });
}

exports.asSingleton = asSingleton;
/**
 * Given an instance of `Eq<V>`, returns a function to fold an array of `V`s
 * into a set of `V`s
 */

exports.fold = function (E) {
  return function (vs) {
    return vs.reduce(function (acc, v) {
      return Set_1.union(E)(acc, Set_1.singleton(v));
    }, Set_1.empty);
  };
};
/**
 * assert a given value appears in the given enumeration
 * @throws {Error} an error if the value does not appear in the given enumeration
 */


function assertIsEnumValue(value, sourceEnum) {
  var enumValues = Object.values(sourceEnum);

  if (!enumValues.includes(value)) {
    throw new errors_1.EnumMemberNotFoundError(value, enumValues);
  }
}

exports.assertIsEnumValue = assertIsEnumValue;
/**
 * Accepts a string | number and casts it to an enum type, throwing an
 * error if the given value is not assignable to the given enum
 */

exports.coerceEnumValue = function (value, sourceEnum) {
  assertIsEnumValue(value, sourceEnum);
  return value;
};